import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=cbd55776&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbd55776')) {
      api.createRecord('cbd55776', component.options)
    } else {
      api.reload('cbd55776', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=cbd55776&", function () {
      api.rerender('cbd55776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/UserProfile.vue"
export default component.exports